import EquationParser from 'scoreboard/components/equations/equation-parser'
import _ from 'lodash'

export default function(columnAttributeMap) {
	let pattern = _(columnAttributeMap)
		.map(attr => String.raw`\b${attr.id}\b`)
		.join('|')

	const parser = new EquationParser({
		patternKeys: [pattern],
		methods: [ 'column' ]
	})

	parser.column = function(parsed) {
		let basics = {
			match: parsed[0],
			type: 'column'
		}
		return basics
	}
	return parser
}
